import './level_type_aboutCompany.css';

export * from 'client/common/components/level/_type/level_type_aboutCompany';
